import { fetchArticle } from '@elevio/kb-kit/lib/api/article';
import { Categories } from '@elevio/kb-kit/lib/components';
import * as Search from '@elevio/kb-kit/lib/components/search';
import { useCategories } from '@elevio/kb-kit/lib/hooks';
import { useEffect, useState } from 'react';
import CategoryCard from '../components/CategoryCard';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { MainSection } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import { fetchAgencyFlags } from '../requests/agency-flags';
import { homeArticleIds } from '../utils/constants';
import { privateSubmissionUrl } from '../utils/privateSubmissionUrl';
const AGENCY_ID = 74;
const openPrivateSubmission = (path) => {
    const url = privateSubmissionUrl(path);
    if (!url) {
        return;
    }
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
        newWindow.opener = null;
    }
};
export const getHeader = () => {
    return (<Header hideSearch>
      <div className="home-hero-section">
        <h1 className="home-hero-title">Customer Portal</h1>
        <Search.Input placeholder="Search portal..." data-testid="search-input" className="hero-search-center"/>
      </div>
    </Header>);
};
const HomePage = () => {
    useCategories();
    const [articles, setArticles] = useState([]);
    const [showViewAllRequests, setShowViewAllRequests] = useState(false);
    useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const responses = await Promise.all(homeArticleIds.map((id) => fetchArticle(id, '1')));
                setArticles(responses);
            }
            catch (error) {
                console.error('Error fetching articles:', error);
            }
        };
        fetchArticles();
    }, []);
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('create');
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('listing');
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('public-map');
    };
    const submitRequestUrl = privateSubmissionUrl('create');
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        <section className="button-container button-container--three">
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleSubmitRequest}>
              <img src={`${window.assetsLocation}/images/request.svg`} alt="request icon" aria-hidden/>
              Submit a Request
            </button>
          </div>
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewMyRequests}>
              <img src={`${window.assetsLocation}/images/inbox.svg`} alt="inbox icon" aria-hidden/>
              View My Requests
            </button>
          </div>
          {showViewAllRequests ? (<div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                <img src={`${window.assetsLocation}/images/map.svg`} alt="map icon" aria-hidden/>
                View All Requests
              </button>
            </div>) : null}
        </section>
        <section className="home-categories-grid">
          <a href={submitRequestUrl} target="_blank" rel="noopener noreferrer" className="card category-card submission-card">
            <div className="card-icon-circle">!</div>
            <h2 className="card-title">Report Issue / Ask Question</h2>
            <span className="card-link">Click here to start a submission</span>
          </a>
          <Categories.Loop>
            <CategoryCard />
          </Categories.Loop>
        </section>
      </MainSection>
    </PageLayout>);
};
export default HomePage;
